import EscalationSupportTable from './EscalationSupportTable';

export default EscalationSupportTable;
